import React from 'react';
import styled from 'styled-components';


const Inf= styled.div`
    padding:10px;
    width:700px;
    height: auto;
    padding:10px;
    background-color: #D7EBEB;
    position: relative;
    margin-top: 4em;
    margin-left: 25em;
 h3{
     color:#005A4B;
     padding:10px;
     text-transform: uppercase;
     text-align: center;
     font-size:20px;
 }

 h5{
     text-transform: capitalize;
     text-align: center;
     color: #46AFA0;
     font-size:15px;
 }
 p{
     color:#333333;
     text-align: center;
     font-size:10px;
 }

 @media screen and (max-width: 700px) {
    margin-top: 2em;
    margin-left: 4em;
    width: 400px;
    overflow: auto;
h3{
    
     font-size:calc(4px + 1.5vw);
 }

 h5{
  
     font-size:calc(3px + 1.5vw);
 }
 p{
     
     font-size:calc(2px + 1.5vw);
 }
 }


 @media screen and (max-width: 500px) {
    width:100%;
    height: auto;
    margin-top: 1em;
    margin-left: -1em;
    overflow: auto;
 }
    `;




function InfoMat () {
    
    return (
        <Inf>
         <h3>matsedel</h3>
         <h5>måndag</h5>
         <p>chorizo med sambalamajonäs</p>
         <p>veg. syakorv med sambalamajonäs</p>
         <h5>tisdag</h5>
         <p>chorizo med sambalamajonäs</p>
         <p>veg. syakorv med sambalamajonäs</p>
         <h5>onsdag</h5>
         <p>chorizo med sambalamajonäs</p>
         <p>veg. syakorv med sambalamajonäs</p>
         <h5>torsdag</h5>
         <p>chorizo med sambalamajonäs</p>
         <p>veg. syakorv med sambalamajonäs</p>
         <h5>fredag</h5>
         <p>chorizo med sambalamajonäs</p>
         <p>veg. syakorv med sambalamajonäs</p>
        </Inf>
    )
}

export default InfoMat;